import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Receipt } from "../../OrderMFE/Receipt/types/receipt";

export interface ReceiptState {
  receiptList: Receipt[];
  receiptDetail: Receipt | null;
}

const initialState: ReceiptState = {
  receiptList: [],
  receiptDetail: null
};

export const receiptSlice = createSlice({
  name: "receipt",
  initialState,
  reducers: {
    setReceiptList: (state, action: PayloadAction<Receipt[]>) => {
      state.receiptList = action.payload;
    },
    setReceiptDetail: (state, action: PayloadAction<Receipt | null>) => {
      state.receiptDetail = action.payload;
    },
    addReceipt: (state, action: PayloadAction<Receipt>) => {
      const exists = state.receiptList.some(
        (r) => r.receiptId === action.payload.receiptId
      );
      if (!exists) {
        state.receiptList.push(action.payload);
      }
    },
    resetReceiptDetail: (state) => {
      state.receiptDetail = null;
    }
  }
});

export const {
  setReceiptList,
  setReceiptDetail,
  addReceipt,
  resetReceiptDetail
} = receiptSlice.actions;

export default receiptSlice.reducer;
